import { NgModule } from '@angular/core';
import { ApiResourceModule } from "libraries/service/apiResource/apiResource.module";
import { QuotationQuotationsResourceService } from "./quotation-quotations-resource.service";

@NgModule({
 imports: [
     ApiResourceModule,
 ],
 providers: [
     QuotationQuotationsResourceService
 ],
})
export class QuotationQuotationsResourceModule { }
